<template>
    <div class="container-fluid w-100" style="overflow: hidden; background: transparent">
        <navbar :title="$t('menu.inspections')"/>
        <div class="col-sm-12 transparent-bg mt-2" style="overflow: hidden">
            <Transition name="fade">
                <div v-show="!showInspectionWizard" class="col-12 nopads">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs routa-tabs">
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">
                                {{ $t('ins_report.ins_report') }}
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">
                                {{ $t('work_assignment.area_defect') }}
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 2 }" @click="tabIndex = 2">
                                {{$t('inspection_template.inspection_title') }}
                            </button>
                                     </li>
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 3 }" @click="tabIndex = 3">
                                {{ $t('inspectable.inspectable') }}
                            </button>
                                     </li>
                    </ul>
                    <!-- Content -->
                    <div class="tab-content routa-tab-content">
                        <div class="tab-pane fade" :class="{ show: tabIndex === 0, active: tabIndex === 0 }">
                            <inspection-reports ref="reports" :user="user" @add="showInspectionWizard = true"/>
                        </div>
                        <div class="tab-pane fade" :class="{ show: tabIndex === 1, active: tabIndex === 1 }">
                            <work-defects :is-observer="hasObserver(user.roles)" />
                        </div>
                        <div class="tab-pane fade" :class="{ show: tabIndex === 2, active: tabIndex === 2 }">
                            <inspections />
                        </div>
                        <div class="tab-pane fade" :class="{ show: tabIndex === 3, active: tabIndex === 3 }">
                            <inspectables/>
                        </div>
                    </div>
                </div>
            </Transition>
            <Transition name="fade">
                <base-modal v-if="showInspectionWizard" size="xl" hide-header hide-footer>
                    <inspection-wizard  :user="user" @close="showInspectionWizard = false" @closeAndUpdate="hideWizard()"/>
                </base-modal>
            </Transition>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
        </div>
    </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {userHelper} from "@/components/mixins/UserMixin";
import InspectionReports from "@/components/inspections/InspectionReports";
import Inspections from "@/components/inspections/Inspections";
import Inspectables from "@/components/inspections/inspectable/Inspectables";
import InspectionWizard from "@/components/inspections/wizard/InspectionWizard";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import WorkDefects from "@/components/inspections/workdefects/WorkDefects";

export default {
    name: 'InspectionsView',
    components: {
        WorkDefects,
        BaseModal,
        Navbar,
        InspectionWizard,
        Inspectables,
        Inspections,
        InspectionReports,
    },
    mixins: [restApi,userHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            showInspectionWizard: false,
            loading: false,
            tabIndex: 0
        }
    },
    methods: {
        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        },
        hideWizard() {
            this.showInspectionWizard = false
            this.$refs.reports.fetchInspectionReports()
        }
    }
}
</script>

<style>
.tab-title {
    font-size: .9em;
    border: none !important;
    margin-right: .5em;
    margin-left: .5em;
    color: #949494 !important;
    font-weight: bold;
}

.tab-title:hover {
    color: #007BFF;
}

.tab-title-active {
    border-bottom: 2px solid #7FC000 !important;
}

.tab-title-text {
    color: #949494 !important;
    font-weight: bold;
}


.tab-title-text-active {
    color: #000000 !important;
    font-weight: bold;
}


.tab-title-cont {
    height: 2.5em !important;
    padding-top: 1em;
    padding-bottom: 1em;
}

.contract-tabs .nav-link {
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.contract-tabs .nav-tabs {
    height: 3em;
    padding-top: .55em;
}

</style>
